import { Component, OnInit } from '@angular/core';
import { ColumnType, DataTableColumn, DataTableRow } from '../controls/datatable/datatable.component';
import { AdminSettingsRequest, DiscoveredProduct, ProductComponent, ProductExt, ProductInstance, ProductInstanceRow } from 'src/app/model/Product';
import { EventService } from 'src/app/service/event.service';
import { AuthenticationService } from 'src/app/service/authentication.service';
import { SoftwareInventoryService } from 'src/app/service/software-inventory.service';
import { DataService } from 'src/app/service/data.service';
import { Events, MsgPayLoad, WebsocketService } from 'src/app/service/websocket.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Modal } from '../controls/modal/modal.service';
import { ActivityService, ActivityType } from 'src/app/service/activity.service';
import { ProductDataType, ProductTreeType, ProductsComponent } from '../products/products.component';
import { ActivityCapabilitiesRequest, ActivityCapabilitiesType, ActivityTask, ActivityTaskType, TaskStatus } from 'src/app/model/TaskStatus';
import { Subscription, catchError, finalize, map, of, tap } from 'rxjs';
import { Agent } from 'src/app/model/Agent';
import { ActionMenuEvent, ActionMenuIcon, ActionMenuItem } from '../controls/actionmenu/action-menu.component';
import { Utils } from 'src/app/utils';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { InstanceDetailsComponent } from '../dialogs/instance-details/instance-details.component';
import { EnableProductComponent, EnableProductModalConfig } from '../dialogs/enable-product/enable-product.component';
import { Activity } from 'src/app/model/SolutionInfo';
import { LoginCsComponent } from '../dialogs/login-cs/login-cs.component';
import { HttpEventType } from '@angular/common/http';
import { SolutionService } from 'src/app/service/solution.service';

@Component({
    selector: 'app-product-component-admin-settings',
    templateUrl: './product-component-admin-settings.component.html',
    styleUrls: ['./product-component-admin-settings.component.css'],
    standalone: false
})
export class ProductComponentAdminSettingsComponent extends ProductsComponent implements OnInit{
  started: boolean = false;
  uploading: boolean = false;
  agentsLoading: boolean = false;
  title: string = "";
  agentTableTitle: string = $localize`Instances`;
  agentCols: DataTableColumn[] = Array<DataTableColumn>(
    new DataTableColumn("version", $localize`Version`, ColumnType.STRING, false, "8"),
    new DataTableColumn("platform", $localize`Platform`, ColumnType.STRING, false, "10"),
    new DataTableColumn("masterInstanceStatus", $localize`Primary system`, ColumnType.STATUSEXT, false, "12"),
    new DataTableColumn("system", $localize`System`, ColumnType.STRING, false, "21"),
    new DataTableColumn("installPath", $localize`Install path`, ColumnType.STRING, false, "22"),
    new DataTableColumn("url", $localize`URL`, ColumnType.STRING, false, "27"),
  );
  agentRows: DataTableRow[] = [];
  productId:number;
  setupid:string;
  platform:string;
  activeProduct:ProductExt;
  currEnvId:number;
  isQuickAnalysisRequired = false;
  isMasterSystemSelected = true;
  isReload:boolean = false;
  isMasterSystemOnline:boolean = true;
  isSupportHotfix = false;
  selectedInstancesFromPreviousPage:ProductInstanceRow[] = [];  
  activeComponent:ProductComponent;
  activeProductInstances:Record<string, ProductInstance[]>;
  selectAllLabel:string = $localize`Select all`;
  isSelectAllChecked:boolean = true;
  backURL: string;
  agentsTableHeight: string;
  recountSelectedRow: boolean = false;
  isAuthRequired: boolean = false;
  productURL: string = '';
  productToken: string = '';
  adminSettingsData:any;
  adminSettingsActivity:Activity;
  masterSystemCounter:number = 0;
  adminSettingsFileName: string = '';
  desc: string = '';
  warning: string = '';
  adminSettingsFile:any;
  chooseFileDefaultStr:string = $localize`Choose file...`;
  
  adminSettingsForm = new FormGroup({
    adminSettingsFileNameCtrl: new FormControl('', [
      Validators.required
    ]),
    adminSettingsFileSourceCtrl: new FormControl('',[Validators.required])
  });

  constructor(protected eventService: EventService,
    protected authService:AuthenticationService,
    protected siService:SoftwareInventoryService,
    protected dataService:DataService,
    protected wsService: WebsocketService,
    protected router: Router,
    protected modal: Modal,
    protected activityService: ActivityService,
    private route: ActivatedRoute,
    protected solutionService: SolutionService) {
      super(eventService, authService, siService, dataService, wsService, router, modal, activityService, solutionService);
      //check if instances were passed in
      if(this.router.currentNavigation() &&
          this.router.currentNavigation().extras && 
          this.router.currentNavigation().extras.state && 
          this.router.currentNavigation().extras.state.capabilities){
        this.selectedInstancesFromPreviousPage = this.router.currentNavigation().extras.state.instances;
        this.activityCapabilities = this.router.currentNavigation().extras.state.capabilities;
        
        //get logs package capabilities
        if(this.activityCapabilities && this.activityCapabilities.tasks){
          this.activityCapabilities.tasks.forEach((task:ActivityTask) => {
            //get supported product logs
            if(task.type == ActivityTaskType.ADMIN_SETTINGS){
              this.adminSettingsData = task.dataJson;
              this.isAuthRequired = this.adminSettingsData.isAuthRequired;
            }
          });
        }
        this.backURL = this.router.currentNavigation().extras.state.backURL;
        this.initAdminSettings();
      }else{
        this.selectedInstancesFromPreviousPage = undefined;
        this.backURL = undefined;
      }
  }

  get adminSettingsFileNameCtrl() { return this.adminSettingsForm.get('adminSettingsFileNameCtrl'); }
  get adminSettingsFileSourceCtrl() { return this.adminSettingsForm.get('adminSettingsFileSourceCtrl'); }

  ngOnInit(): void {
    this.agentsTableHeight = window.outerHeight < 900 ? 'calc(100vh - 500px)' : 'calc(100vh - 650px)';
    
    this.routeSubscription = this.route.params.subscribe(params => {
      this.productId = +params['productId'];
      this.setupid = params['setupid'];
    });

    this.dataSubscription = this.dataService.getData().subscribe((data:any) => {
      if(data && data.type == ProductDataType.AgentManifest){
        this.isAgentManifestUpdating = data.isAgentManifestUpdating;
      } else if(data && (data.type == ProductDataType.General || data.type == ProductDataType.Updates || data.type == ProductDataType.QuickAnalysis)){
        this.solutionInfo = data.solutionInfo;
        this.isManifestUpdating = this.solutionInfo.manifestStatus.isUpdating;
        this.isReload = this.currEnvId != this.solutionInfo.currentEnvironment.id;
        this.platform = undefined;
        this.isMasterSystemOnline = true;
        const discoveredProductGroup : DiscoveredProduct[] = data.discoveredProductGroup;

        if(discoveredProductGroup.length == 0){
          this.router.navigate(['products/overview']);
        }

        //get platform
        for(let i =0; i < discoveredProductGroup.length; i++) {
          let foundProd:ProductExt[] = (discoveredProductGroup[i].products.filter((prod:ProductExt) => {
            return prod.id == this.productId;
          }))
          if(foundProd.length > 0){
            this.platform = foundProd[0].platform;
            this.isSupportHotfix = foundProd[0].supportHotfix;

            if(this.isSupportHotfix){
              this.isQuickAnalysisRequired = !foundProd[0].isQuickAnalysisValid;
              this.isMasterSystemOnline = foundProd[0].isMasterSystemOnline;
            }
            break;
          }
        };

        if(this.platform && this.isReload){
          this.currEnvId = this.solutionInfo.currentEnvironment.id;
          this.agentRows = [];
          this.isReload = false;
          this.initView();
        }
      }
    });

    this.eventMessageSubscription = this.eventService.eventMessage$.subscribe(msg => {
      if(msg.eventType == Events.ActivityCapabilities){
        if(this.isPendingTransaction(msg.headers.transactionId, true)){
          this.activityCapabilities = JSON.parse(msg.body.msg);
          
          if(this.activityCapabilities.activityType == ActivityCapabilitiesType.ADMIN_SETTINGS){
            //check if download log feature is supported
            if(this.activityCapabilities.ok){
              this.activityCapabilities.tasks.forEach((task:ActivityTask) => {
                //get supported product logs
                if(task.type == ActivityTaskType.ADMIN_SETTINGS){
                  this.adminSettingsData = task.dataJson;
                  this.isAuthRequired = this.adminSettingsData.isAuthRequired;
                }
              });

              this.initAdminSettings();
              this.getAdminSettingsActivity();
            }else{
              this.router.navigate(['./'], { relativeTo: this.route.parent });
            }
          }
        }
      }else if(msg.eventType == Events.AgentStatusOffline){
        //uncheck and disable offline agents
        let isChanged:boolean = false;
        this.agentRows.forEach(row => {
          if(row.data.macAddress == msg.body.id &&
             row.data.system == msg.body.name){
            row.disableCheckbox = true;
            row.selected = false;
            if(row.data.instance && row.data.instance.agent){
              row.data.instance.agent.isOnline = false;
              row.data.agentStatus = Utils.getAgentStatus(row.data.instance.agent);
            }
            isChanged = true;
          }
        });
        if(isChanged){
          this.recountSelectedRow = !this.recountSelectedRow;
        }
      }else if(msg.eventType == Events.AgentStatusOnline){
        //enable checkbox
        let isChanged:boolean = false;
        this.agentRows.forEach(row => {
          if(row.data.macAddress == msg.body.macAddress &&
             row.data.system == msg.body.systemName){
            row.disableCheckbox = false;
            if(row.data.instance && row.data.instance.agent){
              row.data.instance.agent.isOnline = true;
              row.data.agentStatus = Utils.getAgentStatus(row.data.instance.agent);
            }
            isChanged = true;
          }
        });

        if(isChanged){
          this.recountSelectedRow = !this.recountSelectedRow;
        }
      } else if (msg.eventType == Events.ManifestUpdateStarted) {
        this.isManifestUpdating = true;
      } else if (msg.eventType == Events.ManifestUpdateComplete) {
        this.reloadAfterManifestUpdate();
      } else if (msg.eventType == Events.AgentManifestComplete) {
        this.isAgentManifestUpdating = false;
      } else if(msg.eventType == Events.ActivityRefresh){
        this.getAdminSettingsActivity();
      }
    });
  }

  initView() {
    this.isLoading = true;

    this.siService.getProductDetail(this.currEnvId, this.platform, this.productId).pipe(
      tap(resp => {
        this.activeProduct = resp.body;

        let foundComponents = this.activeProduct.components.filter((comp:ProductComponent) => {return comp.setupid === this.setupid});

        if(foundComponents.length > 0){
          this.activeComponent = foundComponents[0];
          this.activeProductInstances = this.activeProduct.instances;
          this.agentRows = [];
          this.title = $localize`Administration Settings`;
          this.dataService.sendData({type: ProductDataType.Title, title: this.title});
          this.dataService.sendData({type: ProductDataType.SelectTree, select: {type: ProductTreeType.COMPONENT,
                                                                            productGroupId: this.activeProduct.groupId,
                                                                            productId: this.productId, 
                                                                            setupid: this.activeComponent.setupid}});
          this.masterSystemCounter = 0;

          for (let key in this.activeProductInstances) {  
            this.activeProductInstances[key].forEach((instance:ProductInstance) => {
              if(instance.isMasterInstance){
                this.masterSystemCounter++;
              }

              let instanceAgent:Agent[] = this.solutionInfo.currentEnvironment.agents.filter((agent:Agent) => {
                return agent.macAddress == key;
              });

              if(instanceAgent.length > 0){
                instance.agent = instanceAgent[0];
              }
              
              //check if the instance were selected from the previous page
              let isError:boolean = !instance.agent.isOnline || instance.instanceURL == undefined || instance.instanceURL == '';
              let isSelected:boolean = !isError;
              let errorMsg:string = "";

              if(!instance.agent.isOnline){
                errorMsg =  $localize`Agent is offline.`;
              }else if(instance.instanceURL == undefined){
                errorMsg =  $localize`The instance URL is required.`;
              }

              if(this.selectedInstancesFromPreviousPage && this.selectedInstancesFromPreviousPage.length > 0){
                let matchedInstance:ProductInstance[] = this.selectedInstancesFromPreviousPage.filter((selectedInstance: ProductInstance) => {
                  return selectedInstance.system == instance.system && selectedInstance.installPath == instance.installPath;
                });

                isSelected = !isError && this.isMasterSystemOnline && matchedInstance.length > 0;
              }


              let actions:ActionMenuItem[] = [new ActionMenuItem("Details", $localize`Details`, ActionMenuIcon.DETAILS, instance, false, true)];
              let row:DataTableRow = new DataTableRow({ system: instance.system,
                                                        installPath: instance.installPath,
                                                        instance: instance,
                                                        macAddress: instance.macAddress,
                                                        platform: instance.platform,
                                                        masterInstanceStatus: instance.isMasterInstance ? {className: 'otsc-icon-status-approve', altText: $localize`This instance is a primary system`} : {className: '', altText: ''},
                                                        version: instance.version,
                                                        url: instance.instanceURL === undefined ? "" : instance.instanceURL,
                                                        metadata: instance.metadata,
                                                      },
                                                      actions,
                                                      isError,
                                                      isSelected,
                                                      false, 
                                                      errorMsg);
              if(isError){
                row.disableCheckbox = isError;
              }
              if(!instance.isMasterInstance){
                row.actions.push(new ActionMenuItem("instanceURL", $localize`Set instance URL`, ActionMenuIcon.SETTINGS, instance, false, true));
              }
              if(this.activeProduct.isMultiComponent) {
                if(instance.setupId == this.setupid){
                  this.agentRows.push(row);
                }
              } else {
                this.agentRows.push(row);
              }
            });
          }

          this.isMasterSystemSelected = this.isSupportHotfix ? this.masterSystemCounter == 1 : true;

          if(!this.isMasterSystemSelected){
            this.router.navigate(['./'], { relativeTo: this.route.parent });
          }
        }else{
          this.router.navigate(['products/overview']);
        }          
      }),
      finalize(() => {
        if(this.activityCapabilities == undefined && this.isLoading){
          this.siService.sendActivityCapabilities(this.wsService.getClientId(), this.wsService.getWSEnvId(), this.addTransaction(),
          new ActivityCapabilitiesRequest(-1, ActivityType.ADMIN_SETTINGS, this.activeProduct.pluginId, this.activeComponent.setupid)).pipe(
          tap(resp => {
          }),
          catchError(resp => {
            Utils.addTaskErrorHeaderMessageEventBanner(this.eventService, "ACTIVITY_CAPABILITIES", undefined);
            this.isLoading = false;
            return of(resp);
          })).subscribe();
        }else{
          this.getAdminSettingsActivity();
        }
      })
    ).subscribe();
  }

  ngOnDestroy() {
    if (this.routeSubscription != undefined) {
      this.routeSubscription.unsubscribe();
    }
    if (this.dataSubscription != undefined) {
      this.dataSubscription.unsubscribe();
    }
    if (this.eventMessageSubscription != undefined) {
      this.eventMessageSubscription.unsubscribe();
    }
  }
  
  validateTasks(): void {
    if(this.isAuthRequired) {
      const sub: Subscription =
          this.modal.open(LoginCsComponent, {
            data: {
              title: $localize`Sign in`,
              description: $localize`In order to apply pre-defined administration settings to the selected instances, you must have a valid administrator user login. Enter your administrator user name, password and click Authenticate.`,
              instance: this.getSelectedAgents()[0],
              mode: 'sign_in',
              current: this.getSelectedAgents()[0].version,
              version: '',
              plugin: this.activeProduct.pluginId,
              confirmCheckboxMsg: $localize`Open Text highly recommends that you validate settings on a test system before applying them to a production instance. Note that some administration settings refer specifically to the instance where they are applied, so you must edit them for each Content Server instance you apply them to.`
            },
            id: 'otsc-products-sign-in-dialog'
          }).afterClosed.subscribe((result: any) => {
            if (result) {
              this.activityCapabilities.tasks.forEach((task:ActivityTask) => {
                //get supported product logs
                if(task.type == ActivityTaskType.ADMIN_SETTINGS){
                  task.dataJson.username = result.userName;
                  task.dataJson.password = result.password;
                }
              });

              this.started = true;
              this.agentRows.forEach((row) => {
                row.disableCheckbox = true;
              });

              //prompt for login
              const formData = new FormData();
              let adminSettingsReq:AdminSettingsRequest = new AdminSettingsRequest(this.solutionInfo.currentEnvironment.id,
                                                                                  this.activeProduct.pluginId,
                                                                                  this.getSelectedInstances(),
                                                                                  this.activityCapabilities);
              formData.append('file', this.adminSettingsFileSourceCtrl.value);
              formData.append('adminSettings', JSON.stringify(adminSettingsReq));
              //apply admin settings
              this.siService.applyAdminSettings(formData).pipe(
                map(event => {
                  switch (event.type) {
                    case HttpEventType.UploadProgress: {
                      this.uploading = true;
                      break;
                    }
                    case HttpEventType.Response:
                      this.uploading = false;
                      let msg = new MsgPayLoad(undefined, {
                        message: $localize`Administration Settings activity was started successfully.`
                      });
    
                      msg.setEvent(Events.SuccessMsg);
                      Utils.addHeaderMessageBanner(this.eventService, msg);
                      this.started = false;
                      return event;
                  }
                })
                ,catchError(resp => {
                  this.uploading = false;
                  this.started = false;
                  this.agentRows.forEach((row) => {
                    row.disableCheckbox = false;
                  });
                  let bannerMsg:MsgPayLoad = new MsgPayLoad(undefined, {
                    message: $localize`Error starting Administration Settings activity. Please try again later.`
                  });
                  bannerMsg.setEvent(Events.ErrorMsg);
                  Utils.addHeaderMessageBanner(this.eventService, bannerMsg);
                  return of(resp);
                })
              ).subscribe();
            }
            sub.unsubscribe();
          });
    }
  }

  isReadyToUpload(): boolean {
    let isReady: boolean = false;
    if(!this.started){
      if(this.adminSettingsForm.valid && this.adminSettingsActivity == undefined && this.getSelectedAgents().length > 0){
        isReady = true;
      }
    }
    return isReady;
  }

  getSelectedAgents(): ProductInstance[] {
    let selectedInstances:ProductInstance[] = [];

    if (this.agentRows !== undefined && this.agentRows.length > 0) {
      this.agentRows.forEach(row => {
        if (row.selected) {
          selectedInstances.push(row.data.instance);
        }
      });
    }
    
    return selectedInstances;
  }

  getSelectedInstances(): any {
    let instancesMap:Object = new Object();

    this.agentRows.forEach( (row: DataTableRow) => {
      if(row.selected){
        if (instancesMap[row.data.macAddress]) {
          instancesMap[row.data.macAddress].push(row.data.installPath);
        }else{
          let installPathList:string[] = [];
          installPathList.push(row.data.installPath);
          instancesMap[row.data.macAddress] = installPathList;
        }
      }
    });

    return instancesMap;
  }
  
  openSetInstanceURLDialog(instance:any): void {

    let productMessage: string = $localize `In order to upload pre-defined administration settings and apply them to ${this.activeProduct.name}, 
                                            the host name and REST communications must be validated.  Enter the information below and click Validate to start the validation.
                                            Once validated, the instance URL will be saved.`
    let hasInstanceURL:boolean = instance.instanceURL && instance.instanceURL != '';
    let scheme:string = undefined;
    let port:string = undefined;
    let path:string = undefined;
    let host:string = instance.system;

    if(hasInstanceURL){
      try{
        let url:URL = new URL(instance.instanceURL);
        scheme = url.protocol + "//";
        host = url.hostname;
        port = url.port;
        path = url.pathname.substring(1);
      }catch(e){
        console.error(e);
      }
    }

    const sub: Subscription =
      this.modal.open(EnableProductComponent, {
        data: new EnableProductModalConfig({systemName: host, macAddress: instance.macAddress}, 
                                            {plugin: this.activeProduct.pluginId, productName: this.activeProduct.name},
                                            this.activityCapabilities, this.solutionInfo, productMessage, false, 
                                            $localize`Validate instance URL`,
                                            scheme,
                                            port,
                                            path),
        id: 'otsc-products-admin-settings-instanceURL-dialog',
        height: '450px'
      }).afterClosed.subscribe((instanceURL: string) => {
        if (instanceURL !== "") {
          //update instance URL
          this.siService.updateProductURL(instance.macAddress, instance.installPath, instanceURL).pipe(
              tap((resp: any) => {
                let status: TaskStatus = resp.body;
                if(status.success){
                  let msg = new MsgPayLoad(undefined, {
                    message: $localize`The instance URL for ${this.activeProduct.name} ${this.activeProduct.version} has been succesfully updated.`,
                  });
                  msg.setEvent(Events.SuccessMsg);
                  Utils.addHeaderMessageBanner(this.eventService, msg);
                } else {
                  let errorMsg = $localize`Error updating the instance URL. Please try again later.`;
                  switch(status.errorCode){
                    case 'UPDATE_URL_UNKNOWN_DB_ERROR':
                    case 'UPDATE_URL_DB_ERROR':
                      errorMsg = $localize`The ${this.activeProduct.name} ${this.activeProduct.version} URL was not updated, please see the logs for more details.`;
                      break;
                    case 'UPDATE_URL_PRODUCT_NOT_FOUND':
                      errorMsg = $localize`The ${this.activeProduct.name} ${this.activeProduct.version} URL was not updated, the product could not be found.`;
                      break;
                  }
                }
              }), finalize(() => {
                this.initView();
              })
            ).subscribe();
        }else{
          if(!hasInstanceURL){
            //uncheck on cancel
            this.agentRows.forEach(row => {
              if(row.data.installPath == instance.installPath){
                row.selected = false;
                return;
              }
            });
          }
        }
        this.recountSelectedRow = !this.recountSelectedRow;
        sub.unsubscribe();
      });
  }

  getMasterInstance(): ProductInstance {
    let masterSystem: ProductInstance = null;
    let keys: string[] = Object.keys(this.activeProductInstances);
    for(let i = 0; i < keys.length; i++){
      let instances = this.activeProductInstances[keys[i]];
      for(let j = 0; j < instances.length; j++){
        if(instances[j].isMasterInstance){
          masterSystem = instances[j];
          break;
        }
      }
      if(masterSystem != null){
        break;
      }
    }
    return masterSystem;
  }

  fileBrowseHandler($event): void {
    if($event.target.files.length > 0){
      this.adminSettingsFileName = $event.target.files[0].name;
      this.adminSettingsFileSourceCtrl.patchValue($event.target.files[0]);
    }else{
      this.adminSettingsFileName = "";
      this.adminSettingsFileSourceCtrl.patchValue("");
    }
  }

  back(): void{
    if(this.backURL == undefined || this.backURL == ''){
      this.router.navigate(['./'], { relativeTo: this.route.parent });
    }else{
      this.router.navigate([this.backURL], { relativeTo: this.route.parent });
    }
  }

  actionMenuClicked(event: ActionMenuEvent): void {
    if(event.name === "Details"){
      this.modal.open(InstanceDetailsComponent, {
        data: {
          instanceMetaData: JSON.parse(event.data[0].metadata),
          productName: this.activeProduct.name + ' ' + this.activeProduct.version,
          supportHotfix: this.isSupportHotfix,
          id: 'otsc-products-admin-settings-details-dialog'
        }
      });
    }else if(event.name === "instanceURL"){
      this.openSetInstanceURLDialog(event.data[0]);
    }
  }

  validateInstance(row:DataTableRow): void {
    if(row.selected && row.data.url == ''){
      this.openSetInstanceURLDialog(row.data);
    }
  }

  containsError(): boolean {
    return this.agentRows.findIndex(row => {return row.error;}) > -1;
  }
  
  goToActivitiesOverview():void {
    this.router.navigate(['/activities/overview']);
  }

  getAdminSettingsActivity():void {
    this.activityService.getAdminSettingsActivity(this.solutionInfo.currentEnvironment.id).pipe(
      tap(resp => {
        if(resp.body?.hostTasks.length > 0 && (resp.body.status == "RUNNING" || resp.body.status == "QUEUED") && resp.body.hostTasks[0].plugin == this.activeProduct.pluginId){
          this.adminSettingsActivity = resp.body
        }else{
          this.adminSettingsActivity = undefined;
          if(this.started){
            this.started = false;
          }
        }

        this.agentRows.forEach((row) => {
          row.disableCheckbox = this.adminSettingsActivity !== undefined;
        })
      }),
      catchError(resp => {
        let bannerMsg:MsgPayLoad = new MsgPayLoad(undefined, {
          message: $localize`Error checking for the latest activity. Please try again later.`
        });
        bannerMsg.setEvent(Events.ErrorMsg);
        Utils.addHeaderMessageBanner(this.eventService, bannerMsg);
        return of(resp);
      }), finalize(() => {
        this.isLoading = false;
      })
    ).subscribe();
  }

  private initAdminSettings(): void {
    switch (this.adminSettingsData.descID) {
      case 'OTCS_ADMIN_SETTINGS_DESC':
        this.desc = $localize`This page allows you to upload pre-defined administration settings and apply them to Content Server instances listed below.`;
        break;
    }
  }
}